import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, isDevMode, provideAppInitializer, inject } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withViewTransitions,
} from '@angular/router';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { metaReducers, reducers } from './reducers/index';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { StocksEffects } from './app/features/companies/store/stocks/stocks.effects';
import { FinancialStatementsEffects } from './app/features/companies/store/financial-statements/financial-statements.effects';
import { HoldersEffects } from './app/features/companies/store/holders/holders.effects';
import { RatiosEffects } from './app/features/companies/store/ratios/ratios.effects';
import { DividendsEffects } from './app/features/companies/store/dividends/dividends.effects';
import { SplitsEffects } from './app/features/companies/store/splits/splits.effects';
import { ForecastsEffects } from './app/features/companies/store/forecasts/forecasts.effects';
import { SectorsEffects } from './app/features/sectors/store/sectors.effects';
import { MessageService } from 'primeng/api';
import { toastInterceptor } from './app/shared/interceptors/toast.interceptor';
import { authInterceptor } from './app/shared/interceptors/auth.interceptor';
import { AuthService } from './app/shared/services/auth.service';
import { firstValueFrom } from 'rxjs';
import { provideAteEditor } from '@flogeez/angular-tiptap-editor';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideAteEditor(),
    provideRouter(
      appRoutes,
      withEnabledBlockingInitialNavigation(),
      withViewTransitions(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'disabled',
      })
    ),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, toastInterceptor])),
    provideAnimationsAsync(),
    provideStore(reducers, { metaReducers }),
    provideEffects([
      StocksEffects,
      FinancialStatementsEffects,
      HoldersEffects,
      RatiosEffects,
      DividendsEffects,
      SplitsEffects,
      ForecastsEffects,
      SectorsEffects,
    ]), // Add effects
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return firstValueFrom(authService.initAuth());
    }),
  ],
};
